<mat-form-field class="language-select-field">
    <mat-select [value]="currentLang" (selectionChange)="changeLanguage($event.value)" disableRipple floatLabel="never">
        <mat-select-trigger>
            <div class="lang-display">
                <img [src]="currentFlagIcon" class="flag-icon" alt="{{ currentLang }} Flag" />
                <span>{{ currentLangName }}</span>
            </div>
        </mat-select-trigger>

        @for (lang of availableLangs; track lang.code) {
            <mat-option [value]="lang.code">
                <div class="lang-option">
                    <img [src]="lang.icon" class="flag-icon" alt="{{ lang.name }} Flag" />
                    <span>{{ lang.name }}</span>
                </div>
            </mat-option>
        } @empty {
            <mat-option disabled>Keine Sprachen verfügbar</mat-option>
        }
    </mat-select>
</mat-form-field>
